module.exports = __webpack_public_path__ + "img/c-08.beb874dd.jpg";